import { render } from "./StandardV2Layout.vue?vue&type=template&id=a3dd3ae0&scoped=true"
import script from "./StandardV2Layout.vue?vue&type=script&lang=js"
export * from "./StandardV2Layout.vue?vue&type=script&lang=js"

import "./StandardV2Layout.vue?vue&type=style&index=0&id=a3dd3ae0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3dd3ae0"]])

export default __exports__